<div class="flex {{(type === 'underlined' || type === 'main-underlined' ) ? 'row-gap-1p25' : 'row-gap-0p375'}}"
  [class.bottom-border]="showBottomBorder"
  [ngClass]="additionalClasses" @tabsAppear>
  <div *ngFor="let tab of tabNames; let i = index"
       class="row-gap-0p25 {{tab.currentClass}} {{tab.isDisabled ? 'opacity0p5 not-clickable' : ''}}"
       [attr.data-qa]="tab.name"
       [ngClass]="tabStyleList"
       (click)="changeTab(i)">
    <span>{{tab.name}}</span>
    <span *ngIf="tab.count > 0" class="tab-counter">{{tab.count}}</span>
    <app-all-icons *ngIf="tab.iconNameAndStyling" [iconNameAndStyling]="tab.iconNameAndStyling"></app-all-icons>
  </div>
</div>
